/* eslint-disable max-len */
const pixelsByOwner = {
  brand: {
    'a5c0154b-ca93-4960-b0a5-d3727386b826': '608442746933717',
  },
  shop: {
    'b08cc742-5ce1-443e-8522-4bc739ec1dd1': '2297729117182943',
    'e7c62bc1-97a1-48e6-a50d-d54bc7d6e6e6': '5373545996029121',
  },
};

// eslint-disable-next-line import/prefer-default-export
export const getPixelForOwner = (ownerType, ownerId) =>
  (pixelsByOwner[ownerType] ? pixelsByOwner[ownerType][ownerId] : undefined);



// WEBPACK FOOTER //
// ./src/app/applicationServices/analytics/fbPixel/ownerPixels.js